import styled from "styled-components";
import { FlexContainerV2 } from "@/components/Atoms/Box";

const PageWrapper = styled(FlexContainerV2)`
  flex-direction: row;
  justify-content: space-around;
  padding-top: 56px;
  margin-bottom: 120px;
  background-color: #ffffff;
  width: 100%;
  gap: 40px;
  @media only screen and (max-width: 1079px) {
    flex-direction: column-reverse;
    gap: 32px;
    padding: 0px 20px;
    margin-bottom: 56px;
  }
`;

export { PageWrapper };
